import { styled } from '@material-ui/core';
import BaseButton from '../BaseButton';

const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'primary':
      return {
        borderColour: theme.palette.xpl.action.secondary,
        fontColour: theme.palette.xpl.text.primary,
        backgroundColour: theme.palette.xpl.background2,
      };
    default:
      return {
        borderColour: theme.palette.xpl.action.secondary,
        fontColour: theme.palette.xpl.text.primary,
        backgroundColour: theme.palette.xpl.background2,
      };
  }
};

export const SubtleButtonComponent = styled(BaseButton)(
  ({ variant, theme }) => {
    const { borderColour, fontColour, backgroundColour } = getColourFromVariant(
      variant,
      theme
    );
    return {
      border: `1px solid transparent`,
      color: fontColour,
      fontWeight: 500,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: backgroundColour,
        // Helps remove sticky effect on mobile devices.
        '@media (hover: none)': {
          backgroundColor: backgroundColour,
        },
      },
      '&:focus': {
        border: `1px solid ${borderColour}`,
        backgroundColor: backgroundColour,
      },
      '@media (hover: none)': {
        '&:focus': {
          border: `1px solid ${borderColour}`,
          backgroundColor: backgroundColour,
        },
      },
      '&:disabled': {
        backgroundColor: backgroundColour,
      },
    };
  }
);
